<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxHide.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="text-container">{{dialogTitle}}</span>
  <button mat-icon-button (click)="closeDialogDetalleEquipo()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card class="card-grey" fxLayout.sm="column" fxLayout.xs="column">
  <mat-card-content>
    <div class="mat-elevation-z4 div-ajusted">
      Nro de Registros : {{ nroRegistros }}
    </div>
    <div class="mat-elevation-z4 div-ajusted div-full">
      <form [formGroup]="equipmentForm">
        <div class="row">
          <div class="col">
            <div class="row-flex" fxLayout.xs="column">
              <div class="col">
                <mat-form-field appearance="outline" class="input-width-small field-wrapper-2em" floatLabel="always">
                      <mat-label>Referencia</mat-label>
                      <input matInput formControlName="reference" required>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                  <mat-label>Fecha</mat-label>
                  <input matInput formControlName="date" required>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex" fxLayout.xs="column">
              <div class="col">
                <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                    <mat-label>Descripción</mat-label>
                    <input matInput formControlName="description" required fxHide.xs>
                    <textarea matInput formControlName="description" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex" fxLayout.xs="column">
              <div class="col">
                <mat-form-field appearance="outline" class="input-width-small field-wrapper-2em" floatLabel="always">
                    <mat-label>Precio/Alquiler</mat-label>
                    <input matInput formControlName="precio" class="input-align-right"  required>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                  <mat-label>COP/Dep</mat-label>
                  <input matInput formControlName="cop" class="input-align-right" required>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex" fxLayout.xs="column">
              <div class="col">
                <mat-form-field appearance="outline" class="input-width-small" floatLabel="always">
                  <mat-label>Costo/Día</mat-label>
                  <input matInput formControlName="costoDiario" class="input-align-right" required>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="input-width-small" floatLabel="always">
                  <mat-label>Fecha COP</mat-label>
                  <input matInput formControlName="copDate" class="input-align-right" required>
                </mat-form-field>
              </div>
              <div class="col checkbox-margin" fxLayoutAlign.xs="start stretch">
                <section>
                  <mat-checkbox [disabled]="true">I.V.A. Exento</mat-checkbox>
                </section>
              </div>
            </div>
          </div>
          <div class="col div-img-detalle">
            <button mat-raised-button type="button" color="primary" [disabled]="statusPdf" class="align-center-middle button-ver-pdf"
              (click)="openPDF(urlPDF)" *ngIf="botonPdf">
              <span class="text-icon-space">Ver PDF</span>
            </button>
            <div style="margin-top: 20px;" *ngIf="!botonPdf"></div>
            <img src={{urlImage}} width="125px" height="130px">
            <button mat-raised-button type="button" color="primary" [disabled]="statusSpecification" class="align-center-middle button-ver-pdf" (click)="openSpecification(specification)">
              <span class="text-icon-space">Especificaciones</span>
            </button>
          </div>
        </div>
        <div class="col">
          <div class="row-flex" fxLayout.xs="column">
            <div class="col checkbox-margin">
              <section>
                <mat-checkbox formControlName="relateDollar">Relacionar Dollar </mat-checkbox>
              </section>
            </div>
            <div class="col">
              <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                <mat-label>Precio/Alquiler $</mat-label>
                <input matInput formControlName="dollarCostPrice" class="input-align-right" required>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div fxLayout="row" fxLayout.md="column" class="row-flex div-nac-imp-van">
          <div fxLayout="row" fxLayout.xs="column" fxLayout.md="row" fxLayout.sm="row" class="col margin-left-5vw"
            style="padding-top: 15px; margin-right: 5vw;">
            <section class="align-center-middle" style="padding-top: 10px;padding-right: 15px;">
              <mat-checkbox formControlName="contributesVan"> Aporta V.A.N </mat-checkbox>
            </section>
            <mat-form-field appearance="outline" class="input-width-small field-wrapper-2em" floatLabel="always">
              <mat-label>Depr. V.A.N. </mat-label>
              <input matInput formControlName="addedValue" class="input-align-right" required>
            </mat-form-field>
            <mat-form-field appearance="outline" class="input-width-small field-wrapper-2em" floatLabel="always">
              <mat-label>VAN</mat-label>
              <input matInput formControlName="addedValue" class="input-align-right" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row-flex" fxLayout.xs="column">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                <mat-label>Comentario </mat-label>
                <input matInput formControlName="commentary" required fxHide.xs>
                <textarea matInput formControlName="commentary" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                <mat-label>Agrupación </mat-label>
                <input matInput formControlName="equipmentGroupingEntity" required fxHide.xs>
                <textarea matInput formControlName="equipmentGroupingEntity" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row" formGroupName="proveedor">
            <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                <mat-label>Proveedor </mat-label>
                <input matInput formControlName="razonSocial" required fxHide.xs>
                <textarea matInput formControlName="razonSocial" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
                <button *ngIf="supplierExists" matSuffix mat-icon-button aria-label="Clear"
                  (click)="openProviderDetails(equipmentForm.controls['proveedor'])">
                  <mat-icon>search</mat-icon>
                </button>
            </mat-form-field>
        </div>
      </form>
    </div>
  </mat-card-content>
</mat-card>
